import { Box, Grid } from '@mui/material'
import React from 'react'
import styles from './insights.module.css';
import { mapApplicationDetails } from '../../utils/mapApplicationDetails';
import { DetailsView } from './DetailsView/DetailsView';
import { getShouldRenderLockUnlockHeader } from '../../utils/insightApplicationPage';

const ApplicationAllDetails = (props: any) => {
    const { appDetails } = props

    const shouldRenderHeader = getShouldRenderLockUnlockHeader(appDetails);

    const mappedData = mapApplicationDetails(appDetails);
    const identityContext = {
        opportunityId: appDetails.opportunityUid,
        firstName: appDetails.firstName,
        lastName: appDetails.lastName,
    };

    const detailSections = [
        { title: "Agent Details", items: mappedData.agent },
        { title: "Application Summary", items: mappedData.summary },
        { title: "Pivot Details", items: mappedData.pivot },
        { title: "Applicant Details", items: mappedData.applicant, noDivider: true },
        { title: "Location Details", items: mappedData.location },
        { title: "Quote Details", items: mappedData.quote },
        { title: "Payment Details", items: mappedData.payment },
        { title: "Verification & System Info", items: mappedData.verification },
        {
            title: "Other Details",
            items: mappedData.others,
            show: mappedData.others?.length > 0,
        },
    ];

    return (
            <Box className={styles.contentGridCtn}>
                <Grid
                    container
                    justifyContent={"space-between"}
                    className={`${styles.mainOutCtn} ${styles.applicationStyles}`}
                    sx={{ background: shouldRenderHeader ? "#F5F8FC" : "#fff" }}
                    columnGap={"15px"}
                >
                    {detailSections
                        .filter(section => section.show !== false) 
                        .map(section => (
                            <DetailsView
                                key={section.title}
                                title={section.title}
                                items={section.items}
                                noDivider={section?.noDivider}
                                identityContext={identityContext}
                            />
                        ))}
                </Grid>
            </Box>
    )
}

export default ApplicationAllDetails
